import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {ExtensionItem} from '@components/extensions-gallery/extension/extension-item'
import {ExtensionCustomUploadButton} from '@components/extensions-gallery/extension/partials/extension-custom-upload-button'
import {Filter} from '@components/extensions-gallery/extensions-gallery'
import {ExtensionStore} from '@components/extensions-gallery/extensions-store'
import {globals} from '@extensions/globals-base'
import {getSortingOptions} from '../../constants'

const TwMain = tw.div`
  flex-1
  px-24
  pb-24
  pt-12
`

const TwTitle = tw.div`
  text-primary
  h1-semibold
  mt-4
  mb-24
`

const TwExperimentsNotice = tw.div`
  py-12
  px-16
  rounded-12
  bg-background-active
  text-secondary
`

// const TwScrollToTopButton = tw.div`
//   sticky
//   left-1/2
//   flex
//   flex-1
//   justify-center
//   items-center
//   bottom-16
//   w-[100px]
//   transform
//   -translate-x-[50px]
// `

interface ExtensionsListMainProps {
  onOpenDetails: (ext: ExtensionStore) => void
  onOpenSettings: (ext: ExtensionStore) => void
  onClickScrollToTop: () => void
  onSortingOptionsChanged: (option: OptionsItem) => void
  activeFilter: Filter
  filteredList: ExtensionStore[]
  isSearchActive: boolean
  searchResultsTitle: string
  activeSortingOption: OptionsItem
}

export const ExtensionsListMain = observer((props: ExtensionsListMainProps) => {
  const {
    onOpenDetails,
    onOpenSettings,
    onSortingOptionsChanged,
    activeFilter,
    filteredList,
    isSearchActive,
    searchResultsTitle,
    activeSortingOption
  } = props

  let extensionItems = <>{Lang.msg.emptySearchResults}</>

  if (filteredList.length) {
    extensionItems = (
      <>
        {filteredList.map(item => (
          <ExtensionItem
            key={item.id}
            extensionStore={item}
            onOpenDetails={() => onOpenDetails(item)}
            onOpenSettings={() => onOpenSettings(item)}
          />
        ))}
      </>
    )
  }

  const isStandalone = globals.standalone

  return (
    <TwMain>
      <div className="flex justify-between">
        <TwTitle>
          {isSearchActive ? searchResultsTitle : activeFilter.title}
        </TwTitle>
        {!isStandalone && (
          <SelectWithDropdown
            icon="IconArrowsSort"
            disabled={filteredList.length === 0}
            className="ml-24 !w-[220px]"
            options={getSortingOptions()}
            onChange={onSortingOptionsChanged}
            placeholder={Lang.msg.myStickers.requireToDefineValue}
            value={activeSortingOption.text}
            variant="new"
          />
        )}
      </div>
      <div className="flex flex-col gap-16 relative">
        {activeFilter.id === 'experiments' ? (
          <TwExperimentsNotice>
            {Lang.msg.extensions.gallery.experimentsNotice}
          </TwExperimentsNotice>
        ) : undefined}
        {extensionItems}

        {globals.allowUploadExtensions && (
          <div className="flex justify-end mt-24">
            <ExtensionCustomUploadButton />
          </div>
        )}

        {/* NOTE: should be shown if scroll top position > ~300,
      also it should be redesigned (need discuss with design team) */}
        {/* <TwScrollToTopButton>
          <ButtonNew
            icon="IconArrowUp"
            color="secondary"
            onClick={onClickScrollToTop}
            style={{color: 'var(--color-primary-action-default)'}}
            className="shadow-md"
            fitWidth
          >
            {Lang.msg.extensions.gallery.scrollToTop}
          </ButtonNew>
        </TwScrollToTopButton> */}
      </div>
    </TwMain>
  )
})
